import React, {Component} from "react";
import {$, jsi} from "../../index";
import {$shutils} from "../../libs/snnh/snnh";
import {popupShow} from "../../libs/redux/actions/popup";
import {
    api,
    apis,
    db_tables,
    DBHelpers,
    errors,
    msg,
    rd,
    sendGet,
    throws,
    type_channel,
    type_media, type_modal, type_modal_icon,
    type_popup
} from "../../vars/rd";
import {connect} from "react-redux";
import DaoPlayerData from "../../modules/dao/player.data";
import DaoPlayerChannel from "../../modules/dao/player.channel";
import ChannelItem from "../components/elements/channel.item";
import DaoPlayerMedia from "../../modules/dao/player.media";
import PlayerMediaItem from "../components/elements/player.media.item";
import {modalHide, modalShow} from "../../libs/redux/actions/modal";
import Visualizer from "../components/elements/visualizer";

/**
 * 하단 플레이어
 */
class Player extends Component {
    timer;
    /** @type {DaoPlayerData} */
    data;

    bgmContainerRef;
    bgmMaskRef;
    bgmTrackRef;
    bgmThumbRef;
    bgmLabelRef;

    cmContainerRef;
    cmMaskRef;
    cmTrackRef;
    cmThumbRef;
    cmLabelRef;

    jQuerybgmThumbRef;
    jQuerycmThumbRef;
    constructor(props) {
        super(props);
        this.msg = msg();

        this.volumnOutsideClickHandler = this.volumnOutsideClick.bind(this);

        this.data = (
            new DaoPlayerData(
                {},
                this.channelChange.bind(this),
                this.mediaChange.bind(this)
            )
        ).init();
        this.tickStream();
        /**
         * @type {{
         *  stream: {type: string, id: string, name: string, current:number, duration: number},
         *  display_volume: boolean,
         *  mute_on_bgm: boolean,
         *  channel: DaoPlayerChannel,
         *  media: DaoPlayerMedia,
         * }}
         */
        this.state = {
            stream: {},
            online: true,
            display_volume: true,
            mute_on_bgm: false,
            channel_ment: null,
            channel: null,
            media: null,
        };
    }


    componentDidMount() {
        this.mounted = true;
        this.jQuerybgmThumbRef = $(this.bgmThumbRef);
        this.jQuerycmThumbRef = $(this.cmThumbRef);

        // 배경 조절
        this.bgmPosition(100);
        // CM 조절
        this.cmPosition(100);

        this.setState({
            display_volume: false,
            mute_on_bgm: this.data.mute_on_bgm
        });

        this.tickStart();
    }

    componentWillUnmount() {
        this.mounted = false;
        if(this.state.display_volume) this.unsetDraggable();

        this.jQuerybgmThumbRef = null;
        this.jQuerycmThumbRef = null;

        this.bgmContainerRef = null;
        this.bgmMaskRef = null;
        this.bgmTrackRef = null;
        this.bgmThumbRef = null;
        this.bgmLabelRef = null;

        this.cmContainerRef = null;
        this.cmMaskRef = null;
        this.cmTrackRef = null;
        this.cmThumbRef = null;
        this.cmLabelRef = null;

        this.tickStop();
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    setDraggable() {
        if(this.jQuerybgmThumbRef) {
            this.jQuerybgmThumbRef.draggable({
                axis: 'x',
                containment: this.bgmContainerRef,
                scroll: false,
                drag: e => this.bgmDrag(e),
                stop: e => this.bgmDrag(e, true),
            });
            this.bgmPosition(this.data.volume_bgm * 100);
        }
        if(this.jQuerycmThumbRef) {
            this.jQuerycmThumbRef.draggable({
                axis: 'x',
                containment: this.cmContainerRef,
                scroll: false,
                drag: (e, ui) => this.cmDrag(e, ui),
                stop: (e, ui) => this.cmDrag(e, ui, true),
            });
            this.cmPosition(this.data.volume_ment * 100);
        }
    }

    unsetDraggable() {
        try {
            if(this.jQuerybgmThumbRef)
                this.jQuerybgmThumbRef.draggable('destroy');
        } catch (e) {}


        try {
            if(this.jQuerycmThumbRef)
                this.jQuerycmThumbRef.draggable('destroy');
        } catch (e) {}
    }


    /**
     * 틱 시작
     */
    tickStart() {
        if(!this.timer) {
            this.timer = window.setInterval(() => this.tickChange(), 1000);
        }
    }

    /**
     * 틱 중지
     */
    tickStop() {
        if(this.timer) window.clearInterval(this.timer);
        this.timer = null;
    }

    /**
     * 틱 변경
     */
    tickChange() {
        (async () => {
            // noinspection ES6RedundantAwait
            const online = await jsi.jsi_network_state() === 1;
            if(this.mounted) {
                if(this.state.online !== online) {
                    this.setState({ online }, () => {
                        if(this.state.online) {
                            this.dispatch(modalHide());
                        } else {
                            this.dispatch(
                                modalShow(
                                    type_modal.warn,
                                    {
                                        icon: type_modal_icon.error,
                                        header: this.msg.network,
                                        message: this.msg.network_offline,
                                        immunity: true
                                    }
                                )
                            );
                        }
                    });
                }
            }
        })();

        this.tickStream();
    }

    tickStream(fn=null) {
        try {
            (async () => {
                const info = await jsi.jsi_get_info();
                if(this.mounted) {
                    this.data.init(info);
                    this.setState({ stream: this.data.stream }, () => {
                        if(fn !== null) {
                            fn.call(this, null);
                        }
                    });
                }
            })();
        } catch (e) {}
    }

    get current_channelid() {
        try {
            return this.state.channel.channelid;
        } catch (e) {}
        return null;
    }

    /**
     * 채널번경
     * @param id
     * @param stream {null|{type: string, at: string, id: string, title: string, current: number, duration: number}}
     */
    channelChange(id, stream=null) {
        try {
            if(!id) throws('');
            if(rd.user.isValid) {
                // 채널정보 서버에서 조회
                if(!stream) {
                    const hasExists = (this.current_channelid === Number(id)) || false;
                    // 동일채널이 없는경우 서버에서 조회
                    if(!hasExists) {
                        const url = api(apis.channel_info, {
                            serviceid: rd.user.serviceid,
                            groupid: rd.user.groupid,
                            chid: id,
                        });
                        sendGet(url)
                            .then(json => {
                            if(!json) throws(msg().api_fail);
                            if(this.mounted) {
                                const channel = new DaoPlayerChannel(json);
                                channel.headline = '재생중인 채널';

                                ////////////////////////////////////////////////////////////////////////////////////////////
                                // 편성 스케줄 관련 검색 프로그램 추가
                                // channel.headline = '스케줄 재생중 (14:00 ~ 17:00)';
                                this.setState({
                                    channel_ment: null,
                                    channel,
                                });
                            }
                        });
                    }
                    // 동일 채널이 존재시 멘트정보 리셋
                    else {
                        // 약간의 딜레이
                        setTimeout(() => {
                            if(this.mounted) {
                                this.setState({
                                    channel_ment: null,
                                });
                            }
                        }, 300);
                    }
                }
                // 방송멘트
                else {
                    // 약간의 딜레이
                    setTimeout(() => {
                        if(this.mounted) {
                            stream.title = id;
                            this.setState({
                                channel_ment: stream,
                            });
                        }
                    }, 300);
                }
            }
        } catch (e) {
            if(this.mounted) {
                this.setState({
                    channel_ment: null,
                    channel: null,
                });
            }
        }
    }

    /**
     * 음원변경
     * @param stream {{type: string, at: string, id: string, title: string, current: number, duration: number}}
     */
    mediaChange(stream) {
        try {
            if(!stream || !stream.id) throws('');
            if(rd.user.isValid && stream.id) {
                let media_json = {}
                const url = api(apis.media_info, {
                    serviceid: rd.user.serviceid,
                    groupid: rd.user.groupid,
                    songid: stream.id,
                });
                sendGet(url)
                    .then(json => {
                        if(!json) throws(msg().api_fail);
                        if(this.mounted) {
                            if(json.hasOwnProperty("ip")) delete json.ip;
                            if(json.hasOwnProperty("runtime")) delete json.runtime;

                            json.date = $shutils.toDateString();
                            json.at = stream.at;
                            json.type = stream.type;
                            json.groupid = rd.user.groupid;
                            json.serviceid = rd.user.serviceid;

                            media_json = {...json};
                        }
                    })
                    .catch(() => {
                        if(this.mounted) {
                            media_json = {
                                songid: stream.id,
                                songname: stream.title,
                                artistname: "-",
                                albumname: null,
                                playtime: Math.floor(stream.duration / 1000),
                                favorite: "N",
                                image: null,
                                date: $shutils.toDateString(),
                                at: stream.at,
                                type: stream.type,
                                groupid: rd.user.groupid,
                                serviceid: rd.user.serviceid,
                            };
                        }
                    })
                    .finally(() => {
                        const media = new DaoPlayerMedia(media_json);
                        this.setState(
                            { media },
                            async () => {
                                // 최근 재생기록
                                await this.mediaSave(media)
                            }
                        );
                        media_json = null;
                    });
            }
        } catch (e) {
            if(this.mounted) {
                this.setState({
                    channel_ment: null,
                    channel: null,
                    media: null,
                });
            }
        }
    }

    /**
     * @param media {DaoPlayerMedia}
     */
    async mediaSave(media) {
        try {
            DBHelpers.openDB()
                .then(async db => {
                    // 오래된곡 삭제 배경
                    try {
                        await db.deleteBulkRemain(db_tables.history, doc => {
                            return doc.type === type_media.bgm;
                        }, rd.playlist_limit);
                    } catch (pe) {
                        errors(pe);
                    }

                    // 오래된곡 삭제 멘트
                    try {
                        await db.deleteBulkRemain(db_tables.history, doc => {
                            return doc.type !== type_media.bgm;
                        }, rd.ment_limit);
                    } catch (pe) {
                        errors(pe);
                    }

                    const exists = await db.select(db_tables.history, doc => {
                        return doc.serviceid === rd.user.serviceid &&
                            doc.groupid === rd.user.groupid &&
                            doc.type === media.type &&
                            doc.songid === media.songid &&
                            doc.at === media.at;
                    });

                    if (!exists) {
                        await db.insert(db_tables.history, media);
                    }
                });
        } catch (e) {
        }
    }

    // 스케줄 표현
    scheduleAt(time) {
        if(time) {
            const date = $shutils.toDate(`${$shutils.toDateString()} ${time}`);
            const is_pm = date ? date.getHours() > 11 : false;
            return time.substring(0, 5) + ` ${is_pm ? 'PM' : 'AM'}`;
        } else {
            return '정보없음';
        }
    }

    volumeToggle(display_volume=undefined) {
        if(display_volume === undefined) display_volume = !this.state.display_volume;
        this.setState({display_volume}, () => {
            if(this.state.display_volume) this.setDraggable();
            else this.unsetDraggable();

            this.volumnOutsideHandler();
        });
    }

    volumnOutsideHandler() {
        if(this.state.display_volume) document.addEventListener('click', this.volumnOutsideClickHandler);
        else document.removeEventListener('click', this.volumnOutsideClickHandler);
    }

    volumnOutsideClick(e) {
        if(!this.isVolumnTarget(e.target)) this.volumeToggle(false);
    }

    isVolumnTarget(eventTarget) {
        return eventTarget && eventTarget.closest('.volume');
    }

    getRect(el) {
        return el ? el.getBoundingClientRect() : {};
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /// bgm 볼륨
    /**
     * 백그라운드 볼륨 음소거 클릭
     */
    bgmMute() {
        this.setState(
            {mute_on_bgm: !this.state.mute_on_bgm},
            () => {
                jsi.jsi_set_mute('bgm', (this.state.mute_on_bgm ? 'on' : 'off'));
                // jsi.jsi_set_mute('master', (this.state.mute_on_bgm ? 'on' : 'off'));
            }
        );
    }

    /**
     * 백그라운드 볼륨 UI 썸네일 정보
     * @returns {number}
     */
    get bgmThumbWidth() {
        return this.bgmThumbRef.offsetWidth;
    }

    /**
     * 백그라운드 볼륨 UI 크기
     * @returns {number}
     */
    get bgmWidth() {
        try {
            return this.bgmMaskRef.offsetWidth - this.bgmThumbWidth;
        } catch (e) {
            return 0;
        }
    }

    /**
     * 백그라운드 볼륨 클릭
     * @param e
     */
    bgmClick(e) {
        const background = e.target;
        if(background) {
            const backgroundRect = this.getRect(background);
            const position = ((e.clientX - backgroundRect.left) / this.bgmWidth) * 100;
            this.bgmPosition(position, true);
        }
        $shutils.ignoreEvents(e);
    }

    /**
     * 백그라운드 볼륨 썸네일 드래그
     * @param e
     * @param ended
     */
    bgmDrag(e, ended=false) {
        try {
            const thumbRect = this.getRect(e.target);
            const backgroundRect = this.getRect(this.bgmMaskRef);
            const position = Math.ceil(((thumbRect.left - backgroundRect.left) / this.bgmWidth) * 100);
            this.bgmPosition(position, ended);
        } catch (e) {}
    }

    /**
     * 백그라운드 볼륨 썸네일 위치
     * @param percent
     * @param ended
     */
    bgmPosition(percent, ended=false) {
        try {
            percent = Math.min(100, Math.max(0, Math.floor(percent)));
            if(isNaN(percent)) percent = 90;
            const width = this.bgmWidth;
            const pixel = width * (percent * 0.01);
            $(this.bgmTrackRef).css('left', `${(width - pixel + (this.bgmThumbWidth / 2)) * -1}px`);
            $(this.bgmThumbRef).css('left', `${pixel}px`);
            $(this.bgmLabelRef).text(percent);

            if(ended) {
                const volume = percent * 0.01;
                jsi.jsi_set_volume('bgm', 'set', volume);
                // jsi.jsi_set_volume('master', 'set', volume);
            }
        } catch (e) {}
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /// cm 볼륨

    /**
     * 방송 볼륨 썸네일 크기
     * @returns {number}
     */
    get cmThumbWidth() {
        return this.cmThumbRef.offsetWidth;
    }

    /**
     * 방송 볼륨 배경 크기
     * @returns {number}
     */
    get cmWidth() {
        try {
            return this.cmMaskRef.offsetWidth - this.cmThumbWidth;
        } catch (e) {
            return 0;
        }
    }

    /**
     * 방송 볼륨 배경 클릭
     * @param e
     */
    cmClick(e) {
        const background = e.target;
        if(background) {
            const backgroundRect = this.getRect(background);
            const position = ((e.clientX - backgroundRect.left) / this.cmWidth) * 100;
            this.cmPosition(position, true);
        }
        $shutils.ignoreEvents(e);
    }

    /**
     * 방송 볼륨 썸네일 드래그
     * @param e
     * @param ui
     * @param ended
     */
    cmDrag(e, ui, ended=false) {
        try {
            const min = this.cmWidth * 0.2;
            if(ui.position.left < min) ui.position.left = min;

            const thumbRect = this.getRect(e.target);
            const backgroundRect = this.getRect(this.cmMaskRef);
            const position = Math.ceil(((thumbRect.left - backgroundRect.left) / this.cmWidth) * 100);
            this.cmPosition(position, ended);
        } catch (e) {}
    }

    /**
     * 방송 볼륨 썸네일 위치
     * @param percent
     * @param ended
     */
    cmPosition(percent, ended=false) {
        try {
            percent = Math.min(100, Math.max(20, Math.floor(percent)));
            if(isNaN(percent)) percent = 90;
            const width = this.cmWidth;
            const pixel = width * (percent * 0.01);
            $(this.cmTrackRef).css('left', `${(width - pixel + (this.cmThumbWidth / 2)) * -1}px`);
            $(this.cmThumbRef).css('left', `${pixel}px`);
            $(this.cmLabelRef).text(percent);

            if(ended) {
                const volume = percent * 0.01;
                jsi.jsi_set_volume('cm', 'set', volume);
                jsi.jsi_set_volume('alertcm', 'set', volume);
                jsi.jsi_set_volume('alert', 'set', volume);
                jsi.jsi_set_volume('effect1', 'set', volume);
                jsi.jsi_set_volume('effect2', 'set', volume);
                jsi.jsi_set_volume('effect3', 'set', volume);
                jsi.jsi_set_volume('soundid', 'set', volume);
            }
        } catch (e) {}
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    async playlist() {
        DBHelpers.openDB()
            .then(async db => {
                const histories = [];
                let _histories = await db.selectBulk(db_tables.history, doc => {
                    return doc.type === type_media.bgm &&
                        doc.groupid === rd.user.groupid &&
                        doc.serviceid === rd.user.serviceid;
                });
                _histories = (_histories || []).reverse();
                _histories.forEach(_history => {
                    if (rd.playlist_limit > histories.length) histories.push(new DaoPlayerMedia(_history));
                });

                this.dispatch(
                    popupShow(
                        type_popup.history,
                        [
                            histories,
                            this.data
                        ],
                        null
                    )
                );
            });
    }

    get progress() {
        try {
            if(this.state.stream) {
                if(!this.state.stream.duration) return 0;
                return (this.state.stream.current / this.state.stream.duration) * 100;
            }
        } catch (e) {
            return 0;
        }
    }

    /**
     * 재생상태 변경 콜백
     * 뮤트상태 재생정보 변경
     * @param is_play
     */
    playCallback(is_play) {
        if(is_play) {
            jsi.jsi_set_mute('master', 'off');
            this.tickStart();
        } else {
            jsi.jsi_set_mute('master', 'on');
            this.tickStop();
        }
    }

    render() {
        return (
            <div>
                <div className={`volume ${this.state.display_volume ? '' : 'hide'}`}>
                    <div className="volume-wrap">
                        <h2>볼륨 컨트롤러<span><img src="/images/icon-close-w.png" alt={'닫기'} onClick={() => this.volumeToggle(false)}/></span></h2>
                        <div className="item">
                            <h3>음악 볼륨</h3>
                            <div id="volume-bgm" className="controller-wrap">
                                <div className="volume-icon"
                                     onClick={() => this.bgmMute()}>
                                    <img src={`/images/${!this.state.mute_on_bgm ? 'icon-volume' : 'icon-mute'}.png`} alt={'음소거'}/>
                                </div>
                                {/*  <div id="slider"></div> */}
                                <div className="slider-container"
                                     ref={el => {this.bgmContainerRef = el}}>
                                    {/*  채워지는 부분 */}
                                    <div className="slider-fill-mask"
                                         onClick={e => this.bgmClick(e)}
                                         ref={el => {this.bgmMaskRef = el}}>
                                        <div className="slider-fill"
                                             ref={el => {this.bgmTrackRef = el}}></div>
                                    </div>
                                    {/*  슬라이더 핸들 */}
                                    <div className="slider-thumb"
                                         ref={el => {this.bgmThumbRef = el}}></div>
                                </div>
                                <div className="volume-num"
                                     ref={el => {this.bgmLabelRef = el}}>0</div>
                            </div>
                        </div>
                        <div className="item">
                            <h3>방송 볼륨</h3>
                            <h4>방송 볼륨은 20 미만으로 낮출 수 없어요.</h4>
                            <div className="controller-wrap">
                                <div className="volume-icon">
                                    <img src="/images/icon-volume-g.png" alt={''}/>
                                </div>
                                <div className="slider-container min-vol"
                                     ref={el => {
                                         this.cmContainerRef = el
                                     }}>
                                    {/* 채워지는 부분 */}
                                    <div className="slider-fill-mask"
                                         onClick={e => this.cmClick(e)}
                                         ref={el => {
                                             this.cmMaskRef = el
                                         }}>
                                        <div className="slider-fill"
                                             ref={el => {
                                                 this.cmTrackRef = el
                                             }}></div>
                                    </div>
                                    {/* 슬라이더 핸들 */}
                                    <div className="slider-thumb"
                                         ref={el => {this.cmThumbRef = el}}></div>
                                </div>
                                <div className="volume-num"
                                     ref={el => {this.cmLabelRef = el}}>20</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="player">
                    <div className="player-state">
                        <div className="progress-bar" style={{width: `${this.progress}%`}}></div>
                    </div>
                    <div className="player-wrap">
                        {/* 재생중인 채널/멘트 정보 */}
                        {
                            this.state.channel_ment ?
                                <div className="channel-info2">
                                    <div className="channel-title-wrap">
                                        <div className="channel-title">
                                            {this.state.channel_ment.title}
                                            <span>
                                                <img src="/images/icon-clock2.png" alt={this.state.channel_ment.title} />
                                                {this.scheduleAt(this.state.channel_ment.at)}
                                            </span>
                                        </div>
                                    </div>
                                </div> :
                                this.state.channel ?
                                    <ChannelItem data={this.state.channel} type={type_channel.player} popup={true}/> :
                                    <div className="channel-info">
                                        <div className="channel-title-wrap">
                                            <div className="channel-title">
                                                <img src="/images/icon-alert.png" alt="알림"/>
                                                {this.msg.empty_player_channel}
                                            </div>
                                        </div>
                                    </div>
                        }

                        {/*재생 음원 정보*/}
                        <div className="control-wrap">
                            <div className="icon-playlist">
                                <img src="/images/icon-playlist.png" alt={''} onClick={() => this.playlist()}/>
                            </div>

                            {
                                this.state.media ?
                                    <PlayerMediaItem data={this.state.media}
                                                     current={this.state.stream.current || 0}
                                                     playCallback={this.playCallback.bind(this)} /> :
                                    <div className="title-wrap">
                                        <div className="artist">{this.msg.empty_player_media}</div>
                                    </div>
                            }
                        </div>

                        {/* 볼륨 컨트롤 */}
                        <div className="volume-wrap" onClick={() => this.volumeToggle()}>
                            <img src="/images/icon-volume.png" alt="볼륨확인" /> 볼륨
                        </div>

                        <a onClick={() => this.volumeToggle()}><Visualizer /></a>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(Player);


// WEBPACK FOOTER //
// ./src/pages/include/player.jsx